module.exports = __webpack_public_path__ + "media/SendHelpTutorialVideo.06d4edc6.mp4";